export default __webpack_public_path__ + "static/tony-599b0cc11370947875e11e4ebff6bdf4.png";